import { makeStyles } from "@material-ui/core";
import React from "react";

import { useAuth } from "../../features/auth/context";
import { Search } from "../Search";

import { BannerAboutDeactivation } from "./BannerAboutDeactivation";
import { SiteInactiveBanner } from "./SiteInactiveBanner";
import { SiteMaintenanceModeBanner } from "./SiteMaintenanceModeBanner";
import { SiteOfflineBanner } from "./SiteOfflineBanner";
import { useSite } from "./useSite";

const useStyles = makeStyles((theme) => ({
    container: {
        backgroundColor: "transparent",
        padding: "12px 0 4px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        justifyContent: "center",
        alignItems: "stretch",
    },
}));

export function TopBar() {
    const classes = useStyles();
    const site = useSite();
    const { isGlobalAdmin, isDealerAdmin } = useAuth();
    const showSearch = isDealerAdmin || isGlobalAdmin;

    return (
        <div className={classes.container}>
            <BannerAboutDeactivation />
            <SiteOfflineBanner site={site} />
            <SiteInactiveBanner site={site} />
            <SiteMaintenanceModeBanner site={site} />
            {showSearch && <Search />}
        </div>
    );
}
